export enum UserModulePushStatus {
	SENT = 'SENT', // SENT
	OPENED = 'OPENED', // OPENED
	FAILED = 'FAILED', // FAILED
	STARTED = 'STARTED', // STARTED
	PENDING = 'PENDING', // PENDING
	REFUSED = 'REFUSED',
	ANSWERED = 'ANSWERED', // ANSWERED
	DELIVERED = 'DELIVERED', // DELIVERED
}
